import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  LabelQueryCriteriaClass,
  LabelCriteriaModelQuery,
} from "../../criteria";
import { Core2Config, ApiVisa, ApiResponseModel } from "../shared";
import { BaseApiPublicLoginTemplateService } from "../shared/base-api-public-login-template.service";
import { WMSItemLabelContainerModel } from "../../../../../models/aggregates/warehouse/index";

@Injectable({
  providedIn: "root",
})
export class WMSItemLabelService extends BaseApiPublicLoginTemplateService<
  WMSItemLabelContainerModel,
  WMSItemLabelContainerModel,
  WMSItemLabelContainerModel
> {
  readonly url =
    Core2Config.DOMAIN_TEST_URL +
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.ERP_PREFIX +
    "labels";
  static readonly LABEL_SUB_PATH =
    "labels/" + BaseApiPublicLoginTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_TEST_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-labels/" +
      BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-labels/" +
      BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
    this.endpoint_path_public_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-labels/" +
      BaseApiPublicLoginTemplateService.PUBLIC_EP;
    this.endpoint_path_login_url =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "wms-item-labels/" +
      BaseApiPublicLoginTemplateService.BACKOFFICE_EP;
  }

  getPromiseByCriteria(
    visa: ApiVisa,
    criteria?: LabelQueryCriteriaClass
  ): Promise<ApiResponseModel<WMSItemLabelContainerModel>> {
    const buildDocCriteria = new LabelCriteriaModelQuery(criteria);
    console.log("buildDocCriteria: ", buildDocCriteria);
    console.log("OverRide: ", buildDocCriteria.query);
    const UrlByCriteria = this.apiUrl + "/query?" + buildDocCriteria.query;
    return this.httpClient
      .get<ApiResponseModel<WMSItemLabelContainerModel>>(
        UrlByCriteria,
        this.getHttpHeader(visa)
      )
      .toPromise();
  }

  getByCriteriaObservable(
    visa: ApiVisa,
    criteria?: LabelQueryCriteriaClass
  ): Observable<ApiResponseModel<WMSItemLabelContainerModel>> {
    const buildDocCriteria = new LabelCriteriaModelQuery(criteria);
    const apiUrl = visa.api_domain_url + this.endpoint_path;
    const UrlByCriteria = apiUrl + "/query?" + buildDocCriteria.query;
    return this.httpClient.get<ApiResponseModel<WMSItemLabelContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  updateImageAndDetails(formData: FormData, imageGuid, httpOptions) {
    const url = this.apiUrl + "/replace-file/" + imageGuid;
    return this.httpClient.put(url, formData, httpOptions);
  }

  replaceImageAndDetails(formData: FormData, imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/replace-file/" + imageGuid;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }

  uploadImageAndDetails(formData: FormData, subjectGuid, httpOptions) {
    const url = this.apiUrl + "/add-files/" + subjectGuid;
    return this.httpClient.put(url, formData, httpOptions);
  }

  addImageAndDetails(formData: FormData, subjectGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/add-files/" + subjectGuid;
    return this.httpClient.put(url, formData, this.getHttpHeader(visa));
  }
  getImageDetails(imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/file/" + imageGuid;
    return this.httpClient.get(url, this.getHttpHeader(visa));
  }
  deleteImageDetails(imageGuid, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/file/" + imageGuid;
    return this.httpClient.delete(url, this.getHttpHeader(visa));
  }

  public getFile(extGuid: string, visa: ApiVisa): Observable<Blob> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + "/file/" + extGuid;

    return this.httpClient.get<Blob>(url, {
      headers: new HttpHeaders({
        authorization: visa.jwt_secret,
        responseType: "blob",
        tenantCode: visa.tenantCode,
      }),
      responseType: "blob" as "json",
    });
  }
}
